module.exports = "//static.hsappstatic.net/conversations-embed/static-1.28730/sass/messagesWidgetShell.sass"